<template>
  <div>
    <d-row no-gutters class="page-header py-4 mb-2">
      <d-col
        col
        :sm="isInPopup ? 12 : 6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <template v-if="isInPopup">
          <h4>Lista wizyt</h4>
        </template>
        <template v-else>
          <h4>Historia wizyt dziecka:
            <p class="mt-1 mb-0 patient-name">
              {{ patient.name + ' ' + patient.last_name }}
            </p>
          </h4>
        </template>
      </d-col>
      <d-col
        v-if="!isInPopup"
        col sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          @click.prevent="$router.push('/wizyty/dodaj/' + patient.id)"
          :disabled="!loaded">
          <i class="material-icons">add</i>
          Dodaj nową wizytę
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="allDataLoaded"
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="visits-filters-form"
        tag="form"
        class="d-flex w-100">
        <v-select
          class="mr-2 select-block w-100"
          :options="allInstitutions"
          :reduce="obj => obj.id"
          v-model="filters.institution_id"
          placeholder="Wybierz placówkę..."
          label="name">
        </v-select>
        <d-input
          placeholder="Podaj nazwe pacjenta lub specjalisty"
          v-model="filters.search" />
        <v-select
          class="ml-2 select-block w-100"
          :options="services"
          :reduce="obj => obj.id"
          v-model="filters.service_id"
          placeholder="Wybierz usługę..."
          label="name">
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card class="w-100" style="box-shadow: none;">
      <table class="table mt-0 mb-0 w-100">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Dzień wizyty</th>
            <th scope="col" class="border-0">Godzina wizty</th>
            <th scope="col" class="border-0">Specjalista</th>
            <th scope="col" class="border-0">Usługa</th>
            <th scope="col" class="border-0">Placówka</th>
            <th v-if="!isInPopup" scope="col" class="border-0 text-center">Podgląd</th>
          </tr>
        </thead>
        <tbody v-if="allDataLoaded">
          <tr
            v-for="(patientVisit, indexNewVisits) of visits"
            v-if="patient.id === patientVisit.patient_id"
            :key="'patient-visit-data-' + indexNewVisits">
            <td class="align-middle">
              {{ patientVisit.date_start.slice(0, 10) }}
            </td>
            <td class="align-middle">
              {{ patientVisit.date_start.slice(11, 16) }}
            </td>
            <td class="align-middle">
              {{ getUserName(patientVisit.user_id) }}
            </td>
            <td class="align-middle">
              {{ patientVisit.service_type_name }}
            </td>
            <td class="align-middle">
              {{ getIntitutionName(patientVisit.institution_id) }}
            </td>
            <td
              v-if="!isInPopup"
              class="align-middle text-center"
              style="width: 120px">
              <d-button
                outline
                theme="info"
                class="mx-auto"
                @click.prevent="showVisitPopup(patientVisit.id)"
                title="Podgląd">
                <i class="material-icons">person_search</i>
              </d-button>
            </td>
          </tr>
          <tr
            v-if="!visits.length">
            <td
              colspan="6"
              class="text-center">
              Brak wizyt do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import FormUtils from '@/utils/FormUtils.js';
import debounce from 'lodash.debounce';

export default {
  name: 'patients-form-visits',
  props: {
    allInstitutions: {
      type: Array,
      required: true
    },
    allUsers: {
      type: Array,
      required: true
    },
    isInPopup: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    patient: {
      type: Object,
      required: true
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.servicesLoaded;
    },
    userData () {
      return this.$store.getters.getAccount
    },
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue && !this.loaded) {
        this.loadAllData();
      }
    }
  },
  data() {
    return {
      filters: {
        institution_id: '',
        search: '',
        service_id: '',
        user_id: ''
      },
      loaded: false,
      loadError: false,
      visits: [],
      services: [],
      servicesLoaded: false,
    }
  },
  mounted () {
    if (this.isVisible) {
      this.loadAllData();
    }
  },
  methods: {
    loadAllData () {
      this.loadAdditionalData();
      this.loadItemsData();
    },
    loadItemsData () {
      let where = {
        search: this.filters.search,
        patient_id: this.patient.id,
        service_id: this.filters.service_id,
        institution_id: this.filters.institution_id,
        user_id: this.filters.user_id
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/visits/items?ignore_users_filters=1=',
        listField: 'visits',
        pagination: false,
        params: {
          where
        }
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 250),
    validateFiltersForm () {
      FormUtils.validate(this.$refs['visits-filters-form'], this.debouncedLoadFilteredData);
    },
    clearFilters () {
      this.filters = {
        institution_id: '',
        search: '',
        service_id: '',
        user_id: ''
      };
      this.debouncedLoadFilteredData();
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items?ignore_users_filters=1',
        outputKey: 'services',
        loadedKey: 'servicesLoaded',
        params: {
          pagination: false
        },
      });
    },
    getUserName (userID) {
      if (!userID) {
        return 'brak';
      }

      let itemFound = this.allUsers.find(item => item.id === userID);

      if (!itemFound) {
        return 'Nie znaleziono specjalisty';
      }

      return itemFound.name + ' ' + itemFound.last_name;
    },
    getIntitutionName (institutionID) {
      if (!institutionID) {
        return 'brak';
      }

      let itemFound = this.allInstitutions.find(item => item.id === institutionID);

      if (!itemFound) {
        return 'Nie znaleziono placówki';
      }

      return itemFound.name;
    },
    showVisitPopup (visitID) {
      this.$bus.$emit('patient-visit-show-popup', visitID);
    }
  }
}
</script>
